var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5784 4.0332H3.89668C3.12529 4.0332 2.5 4.65849 2.5 5.42988V16.6033C2.5 17.3747 3.12529 18 3.89668 18H15.0701C15.8415 18 16.4668 17.3747 16.4668 16.6033V8.92158",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1257 3.3498L11.2249 11.2506L8.75586 11.7444L9.24965 9.27537L17.1504 1.37458C17.4231 1.10188 17.8653 1.10188 18.138 1.37458L19.1257 2.36221C19.3984 2.63491 19.3984 3.07706 19.1257 3.3498Z",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1626 2.36221L18.1378 4.3374",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic-edit.f5a1e1547fee763671a93c089af8f86f.svg";
export { ForwardRef as ReactComponent };